import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { siteSelectStyles } from '../utils/selectStyles';

const OccurrenceFilters = ({
    filterOptions,
    filters,
    onFilterChange,
    onClearFilters,
}) => {
    return (
        <div className="occurrence-filters">
            <div className="occurrence-filters__dropdown">
                <label className="occurrence-filters__label">Site</label>
                <Select
                    value={filters.site}
                    onChange={(val) => onFilterChange('site', val)}
                    options={filterOptions.sites}
                    placeholder="All Sites"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="occurrence-filters__dropdown">
                <label className="occurrence-filters__label">Department</label>
                <Select
                    value={filters.department}
                    onChange={(val) => onFilterChange('department', val)}
                    options={filterOptions.departments}
                    placeholder="All Departments"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="occurrence-filters__dropdown">
                <label className="occurrence-filters__label">Staff</label>
                <Select
                    value={filters.staff}
                    onChange={(val) => onFilterChange('staff', val)}
                    options={filterOptions.staff}
                    placeholder="All Staff"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="occurrence-filters__dropdown">
                <label className="occurrence-filters__label">Role</label>
                <Select
                    value={filters.role}
                    onChange={(val) => onFilterChange('role', val)}
                    options={filterOptions.roles}
                    placeholder="All Roles"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="occurrence-filters__dropdown">
                <label className="occurrence-filters__label">Occurrence Form</label>
                <Select
                    value={filters.form}
                    onChange={(val) => onFilterChange('form', val)}
                    options={filterOptions.forms}
                    placeholder="All Forms"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="occurrence-filters__date-group">
                <label className="occurrence-filters__label">Date Range</label>
                <div className="occurrence-filters__date-inputs">
                    <input
                        type="date"
                        className="occurrence-filters__date-input"
                        value={filters.dateFrom || ''}
                        onChange={(e) => onFilterChange('dateFrom', e.target.value)}
                    />
                    <input
                        type="date"
                        className="occurrence-filters__date-input"
                        value={filters.dateTo || ''}
                        onChange={(e) => onFilterChange('dateTo', e.target.value)}
                    />
                </div>
            </div>
            <div className="occurrence-filters__search">
                <label className="occurrence-filters__label">Search</label>
                <input
                    type="text"
                    className="occurrence-filters__search-input"
                    placeholder="Search notes, staff..."
                    value={filters.search || ''}
                    onChange={(e) => onFilterChange('search', e.target.value)}
                />
            </div>
            <button className="occurrence-filters__clear-btn" onClick={onClearFilters}>
                Clear Filters
            </button>
        </div>
    );
};

OccurrenceFilters.propTypes = {
    filterOptions: PropTypes.shape({
        sites: PropTypes.array.isRequired,
        departments: PropTypes.array.isRequired,
        staff: PropTypes.array.isRequired,
        roles: PropTypes.array.isRequired,
        forms: PropTypes.array.isRequired,
    }).isRequired,
    filters: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
};

export default OccurrenceFilters;
